var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.FieldsMap,{attrs:{"defaultFields":_vm.fields,"varieties":_vm.varieties,"crops":_vm.crops,"activities":_vm.activities,"activityTypes":_vm.activityTypes,"showMenu":true,"showFieldMarkers":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }